import { Component, DestroyRef, Inject, Input } from '@angular/core';
import { Questionnaire, QuestionType } from '../../../core/models/questionnaire';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DriverService } from '../../../core/services/driver.service'
import { VehicleService } from '../../../core/services/vehicle.service'
import { BehaviorSubject, forkJoin } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { map } from 'rxjs/operators'


@Component({
  selector: 'app-questionnaire-result-preview-modal',
  templateUrl: './questionnaire-result-preview-modal.component.html',
  providers: [{ provide: 'windowObject', useFactory: () => window }],
  preserveWhitespaces: true
})
export class QuestionnaireResultPreviewModalComponent {
  @Input() questionnaire!: Questionnaire;
  @Input()
  set completedBy(completedBy: number) {
    if (completedBy) {
      forkJoin([this.driverService.all(), this.vehicleService.all()])
        .pipe(
          map(([drivers, vehicles]) => [...drivers, ...vehicles].map(employee => employee.account)),
          takeUntilDestroyed(this.destroyRef)
        ).subscribe(accounts => {
        if (accounts && accounts.length > 0) {
          const completedByAccount = accounts.find(account => account && !account.pending && account.accountId === completedBy.toString());
          this.completedByNameSubject.next(completedByAccount && completedByAccount.name);
        }
      });
    }
  }

  protected readonly QuestionType = QuestionType;

  private completedByNameSubject = new BehaviorSubject<string>(null);
  readonly completedByName = this.completedByNameSubject.asObservable();

  constructor(@Inject('windowObject') private readonly window: Window,
              protected readonly activeModal: NgbActiveModal,
              private readonly driverService: DriverService,
              private readonly vehicleService: VehicleService,
              private readonly destroyRef: DestroyRef) {
  }

  open(url?: string): void {
    if (url) {
      this.window.open(url);
    }
  }
}
